'use client';

import { useLocale } from 'next-intl';
import { getMarketingNavigationLinks } from '@/lib/marketing/navigation-links';

export function useMarketingNavLinks(localeOverride?: string) {
  const locale = useLocale();
  return {
    ...getMarketingNavigationLinks(localeOverride ?? locale),
    isLoading: false,
  };
}
